export const generateOtherRequestSystemFunctionId = "57";
